// extracted by mini-css-extract-plugin
module.exports = {"searchDiv":"SearchBox_searchDiv__11chq","searchIcon":"SearchBox_searchIcon__1_A8C","searchedDiv":"SearchBox_searchedDiv__2BNsi","white":"SearchBox_white__2ZR0C"};